import { Box, Flex } from '@chakra-ui/react';
import { CopyIcon } from '@halo/ui-chat-react';
import type { ReactNode } from 'react';

export interface DetailListProps {
  title: ReactNode;
  content: ReactNode;
  onCopy?: () => void;
}

export function DetailList({ title, content, onCopy }: DetailListProps) {
  return (
    <Box className="DetailList" borderBottom="1px solid" borderColor="grey.10" px="1" py="2.5">
      <Box fontSize="xs" fontWeight="medium" color="fg.muted">
        {title}
      </Box>
      <Flex gap="1" justifyContent="space-between" mt="1">
        <Box fontSize="xs" fontWeight="medium" flex="1 1 auto" minW="0" truncate>
          {content}
        </Box>
        {onCopy && (
          <Box cursor="pointer" color="fg.muted" onClick={onCopy}>
            <CopyIcon />
          </Box>
        )}
      </Flex>
    </Box>
  );
}
